import create from 'zustand'

export type RoutePoint = {
  id: number
  name: string
  x: number
  y: number
  type_name: string
  layerId: number
}

type NavigationState = {
  route: { from: RoutePoint | null; to: RoutePoint | null }
  selected: { from: RoutePoint | null; to: RoutePoint | null }
  isRouteActive: boolean
  setFrom: (from: RoutePoint | null) => void
  setTo: (to: RoutePoint | null) => void
  clearSelected: () => void
  startRoute: (from?: RoutePoint | null, to?: RoutePoint | null) => void
  clearRoute: () => void
  resetNavigation: () => void
}

export const useNavigationStore = create<NavigationState>((set, get) => ({
  route: { from: null, to: null },
  selected: { from: null, to: null },
  isRouteActive: false,

  setFrom: (from) =>
    set((state) => ({ selected: { ...state.selected, from } })),
  setTo: (to) => set((state) => ({ selected: { ...state.selected, to } })),
  clearSelected: () => set({ selected: { from: null, to: null } }),

  startRoute: (from, to) => {
    const sel = get().selected
    const f = from ?? sel.from
    const t = to ?? sel.to
    if (!f || !t) return
    set({
      route: { from: f, to: t },
      isRouteActive: true,
    })
  },

  clearRoute: () =>
    set({
      route: { from: null, to: null },
      isRouteActive: false,
    }),

  resetNavigation: () =>
    set({
      route: { from: null, to: null },
      selected: { from: null, to: null },
      isRouteActive: false,
    }),
}))
